<div class="container">
  <app-breadcrumb [items]="breadcrumbs"></app-breadcrumb>
  <app-content-card cardTitle="Items en taken definiëren">
    <p>
      Hier kunt u de items selecteren die onderdeel uitmaken van het handelingsperspectief. Geef per item aan wie verantwoordelijk is voor het invullen van de gegevens. Als het keuzemenu leeg is, dient u eerst andere stakeholders te definiëren onder 'instellingen'.
    </p>
    <div class="time-container" [formGroup]="deadlineForm">
      <mat-form-field>
        <mat-label>Einddatum huidige situatie:</mat-label>
        <input matInput [formControlName]="currentDeadlineFormControlName" [matDatepicker]="currentDatePicker" placeholder="dd-mm-yyyy">
        <mat-datepicker-toggle matIconSuffix [for]="currentDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #currentDatePicker></mat-datepicker>
      </mat-form-field>
        
      <mat-form-field>
        <mat-label>Einddatum ambitie toekomst:</mat-label>
        <input matInput [formControlName]="futureDeadlineFormControlName" [matDatepicker]="futureDatePicker" placeholder="dd-mm-yyyy">
        <mat-datepicker-toggle matIconSuffix [for]="futureDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #futureDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="item-container">
      @for (itemForm of itemForms; track itemForm) {
        <div>
          <app-assign-items-form
            [class]="`${itemForm.itemCategory}-theme`"
            [itemForm]="itemForm"
            [stakeholders]="stakeholders"
            [initiator]="initiator"
            (dataUpdated)="onItemFormUpdate($event)"
          ></app-assign-items-form>
        </div>
      }
    </div>
    <div class="button-row">
      <app-custom-button [buttonSettings]="buttonSettingsConfirm" (click)="onSubmit()" >Bevestigen</app-custom-button>
      <app-custom-button [buttonSettings]="buttonSettingsReset" (click)="reset()" >Annuleren</app-custom-button>
    </div>
  </app-content-card>
